export const MODAL_TYPES = {
  error: 'error',
  delete: 'delete',
  warning: 'warning',
};

export const BADGE_STATES = {
  admin: 'primary-700',
  staff: 'gray-500',
};

export const USER_ROLES = {
  admin: 'instructor',
  staff: 'staff',
};

export const EXAMPLE_USER_EMAIL = 'username@domain.com';
